module.exports = __webpack_public_path__ + "static/media/area-classic-icon.90e777d9.svg";